export const promotedJobs = [
  {
    companyName: 'Walkover web solution pvt ltd',
    date: '2020-20-08T13:41:57',
    description:
      '<div><ul><li>Architecture review and refactor</li>Implements leading tools in the market for monitoring and alerting of infrastructure anomaly.</li><li>Tools configuration for marketing/support/development team to help them analyze data AND giving analysis to concerned team proactively</li><li>Help team to follow best practices</li><li>Participate in hands-on coding on various languages - PHP, java, python.</li><li>Perform thorough and thoughtful code reviews for other engineers on your team</li><li>Help build monitoring solutions that keep the health of our system in check and page when necessary.</li><li>Help troubleshoot and optimize our backend services.</li></ul></div>',
    jobType: 'full_time',
    position: 'Solution Architect',
    salary: '10-20 lpa',
    source: 'RemoteRocket.io',
    url: 'https://walkover.in',
    screenshotUrl:
      'https://coder-flow.s3-eu-west-1.amazonaws.com/random/walkover-screenshot.png',
    companyLogoUrl:
      'https://coder-flow.s3-eu-west-1.amazonaws.com/random/walkover-logo.png',
    tags: [
      'Solution Architect',
      'devops',
      'coding',
      'Terraform and Ansible',
      'microservice architecture',
    ],
  },
];
